module.exports = __webpack_public_path__ + "img/2.6701f877.png";